import { IMyInitialState } from "../types";


export const MyInitialState: IMyInitialState = {
    my: {
        id: -1,
        full_name: '',
        email: '',
        isAuth: false,
        role: 'tutor',
        role_name: '',
        available_features: [],
        feature_grants: [],
    },
    isLoading: false,
    error: ''
} 
